import React, {
  useMemo,
  useState,
  useEffect,
} from "react";

import {
  useParams,
  useNavigate,
  useLocation,
} from "react-router-dom";

import { Eye } from "lucide-react";

import { Button } from "react-bootstrap";

import { saveAs } from "file-saver";

import {
  RiShareForwardLine,
  RiDownloadFill,
} from "react-icons/ri";

import {
  MdOutlineBlock,
  MdOutlineDeleteOutline,
} from "react-icons/md";

import { HiOutlineMail } from "react-icons/hi";

import { FaArrowLeft } from "react-icons/fa6";

import { SiTicktick } from "react-icons/si";

import { ImConfused } from "react-icons/im";

import {
  Document,
  Packer,
  Paragraph,
  TextRun,
} from "docx";

import ApiService from "../nhrc_apis/ApiService";

const { JobAPI } = ApiService;

function Empresponse() {

  const { jobId } = useParams();

  const navigate = useNavigate();

  const location = useLocation();

  const pageSize = 10;

  /* =========================================
      STATES
  ========================================= */

  const [jobTitle, setJobTitle] =
    useState("Unknown Position");

  const [candidates, setCandidates] =
    useState([]);

  const [selectedIds, setSelectedIds] =
    useState([]);

  const [statusFilter, setStatusFilter] =
    useState("all");

  const [nameFilter, setNameFilter] =
    useState("");

  const [emailFilter, setEmailFilter] =
    useState("");

  const [experienceFilter, setExperienceFilter] =
    useState("");

  const [page, setPage] =
    useState(1);

  const [loading, setLoading] =
    useState(false);

  /* =========================================
      LOAD APPLICATIONS
  ========================================= */

  useEffect(() => {

    if (jobId) {

      fetchApplications();
    }

  }, [jobId]);

  const fetchApplications = async () => {

    try {

      setLoading(true);

      console.log(
        "OPEN RESPONSE PAGE JOB ID :",
        jobId
      );

      const response =
        await JobAPI.getApplicationsByJob(
          jobId
        );

      console.log(
        "FULL API RESPONSE :",
        response
      );

      console.log(
        "API RESPONSE DATA :",
        response?.data
      );

      let applications = [];

      /* =========================================
          HANDLE ARRAY RESPONSE
      ========================================= */

      if (
        Array.isArray(response?.data)
      ) {

        applications =
          response.data;

      } else if (
        Array.isArray(
          response?.data?.applications
        )
      ) {

        applications =
          response.data.applications;

      } else if (
        Array.isArray(
          response?.data?.data
        )
      ) {

        applications =
          response.data.data;

      } else {

        applications = [];
      }

      console.log(
        "FINAL APPLICATIONS :",
        applications
      );

      /* =========================================
          FORMAT APPLICATION DATA
      ========================================= */

      const formatted =
        applications.map(
          (item, index) => {

            console.log(
              "APPLICATION ITEM :",
              item
            );

            return {

              id:
                item?.id ||
                item?.application_id ||
                index + 1,

              applicationId:
                item?.id ||
                item?.application_id ||
                "",

              jobId:
                item?.job_id || "",

              firstName:
                item?.first_name || "",

              lastName:
                item?.last_name || "",

              fullName:
                `${item?.first_name || ""} ${item?.last_name || ""}`,

              email:
                item?.email ||
                item?.student_email ||
                "N/A",

              phone:
                item?.phone_number ||
                item?.mobile_number ||
                item?.phone ||
                "N/A",

              experience:
                item?.experience_type ||
                item?.experience ||
                "FRESHER",

              keySkills:
                item?.key_skills ||
                item?.skills ||
                "N/A",

              qualification:
                item?.highest_qualification ||
                "N/A",

              location:
                item?.location ||
                "N/A",

              gender:
                item?.gender ||
                "N/A",

              college:
                item?.college ||
                "N/A",

              university:
                item?.university ||
                "N/A",

              expectedSalary:
                item?.expected_salary ||
                "N/A",

              specialization:
                item?.specialization ||
                "N/A",

              preferredWorkMode:
                item?.preferred_work_mode ||
                "N/A",

              positionAppliedFor:
                item?.position_applied_for ||
                "N/A",

              whyHireMe:
                item?.why_hire_me ||
                "N/A",

              linkedIn:
                item?.linkedin_url ||
                "N/A",

              studentId:
                item?.student_id ||
                "N/A",

              membershipId:
                item?.student_membership_id ||
                "N/A",

              status:
                item?.status ||
                "APPLIED",

              resume:
                item?.resume_file || "",

              photo:
                item?.photo_file || "",

              panCard:
                item?.pan_card_file || "",

              appliedAt:
                item?.applied_at ||
                item?.created_at ||
                "",

              fullData: item,
            };
          }
        );

      console.log(
        "FORMATTED CANDIDATES :",
        formatted
      );

      /* =========================================
          IMPORTANT
      ========================================= */

      setCandidates([...formatted]);

      console.log(
        "CANDIDATES STATE SET SUCCESSFULLY"
      );

    } catch (error) {

      console.log(
        "FETCH APPLICATION ERROR :",
        error
      );

      console.log(
        "ERROR RESPONSE :",
        error?.response?.data
      );

      alert(
        "Failed to load applications"
      );

    } finally {

      setLoading(false);
    }
  };

  /* =========================================
      JOB TITLE
  ========================================= */

  useEffect(() => {

    if (
      location.state?.jobTitle
    ) {

      setJobTitle(
        location.state.jobTitle
      );
    }

  }, [location.state]);

  /* =========================================
      DEBUG
  ========================================= */

  useEffect(() => {

    console.log(
      "UPDATED CANDIDATES :",
      candidates
    );

  }, [candidates]);

  /* =========================================
      COUNTS
  ========================================= */

  const totalResponses =
    candidates.length;

  const shortlistedCount =
    candidates.filter(
      (c) =>
        c.status?.toLowerCase() ===
        "shortlisted"
    ).length;

  const rejectedCount =
    candidates.filter(
      (c) =>
        c.status?.toLowerCase() ===
        "rejected"
    ).length;

  const maybeCount =
    candidates.filter(
      (c) =>
        c.status?.toLowerCase() ===
        "maybe"
    ).length;

  /* =========================================
      FILTERS
  ========================================= */

  const filteredAll = useMemo(() => {

    return candidates.filter((c) => {

      if (
        statusFilter !== "all" &&
        c.status?.toLowerCase() !==
          statusFilter.toLowerCase()
      ) {

        return false;
      }

      if (
        nameFilter &&
        !`${c.firstName} ${c.lastName}`
          .toLowerCase()
          .includes(
            nameFilter.toLowerCase()
          )
      ) {

        return false;
      }

      if (
        emailFilter &&
        !String(c.email)
          .toLowerCase()
          .includes(
            emailFilter.toLowerCase()
          )
      ) {

        return false;
      }

      if (
        experienceFilter &&
        !String(c.experience)
          .toLowerCase()
          .includes(
            experienceFilter.toLowerCase()
          )
      ) {

        return false;
      }

      return true;
    });

  }, [
    candidates,
    statusFilter,
    nameFilter,
    emailFilter,
    experienceFilter,
  ]);

  /* =========================================
      PAGINATION
  ========================================= */

  const totalPages = Math.max(
    1,
    Math.ceil(
      filteredAll.length / pageSize
    )
  );

  const paged = useMemo(() => {

    const start =
      (page - 1) * pageSize;

    return filteredAll.slice(
      start,
      start + pageSize
    );

  }, [filteredAll, page]);

  /* =========================================
      SELECT
  ========================================= */

  const allSelected =
    paged.length > 0 &&
    paged.every((c) =>
      selectedIds.includes(c.id)
    );

  const toggleSelectAll = (e) => {

    if (e.target.checked) {

      setSelectedIds(
        paged.map((c) => c.id)
      );

    } else {

      setSelectedIds([]);
    }
  };

  const toggleSelect = (id) => {

    setSelectedIds((prev) =>

      prev.includes(id)

        ? prev.filter(
            (x) => x !== id
          )

        : [...prev, id]
    );
  };

  /* =========================================
      STATUS BADGE
  ========================================= */

  const getStatusBadgeClass = (
    status
  ) => {

    const s =
      String(status || "")
        .toLowerCase();

    if (s === "shortlisted")
      return "bg-success";

    if (s === "rejected")
      return "bg-danger";

    if (s === "maybe")
      return "bg-warning text-dark";

    return "bg-primary";
  };

  /* =========================================
      STATUS UPDATE
  ========================================= */

  const bulkUpdateStatus =
    async (status) => {

      try {

        for (const id of selectedIds) {

          if (
            status ===
            "Shortlisted"
          ) {

            await JobAPI.shortlistApplication(
              id
            );

          } else if (
            status ===
            "Rejected"
          ) {

            await JobAPI.rejectApplication(
              id
            );
          }
        }

        const updated =
          candidates.map((c) =>

            selectedIds.includes(c.id)

              ? {
                  ...c,
                  status,
                }

              : c
          );

        setCandidates(updated);

        setSelectedIds([]);

      } catch (error) {

        console.log(
          "STATUS UPDATE ERROR :",
          error
        );

        alert(
          "Failed to update status"
        );
      }
    };

  /* =========================================
      DELETE
  ========================================= */

  const handleDelete = () => {

    if (
      selectedIds.length === 0
    ) {

      alert(
        "Please select candidates"
      );

      return;
    }

    const updated =
      candidates.filter(
        (c) =>
          !selectedIds.includes(
            c.id
          )
      );

    setCandidates(updated);

    setSelectedIds([]);
  };

  /* =========================================
      DOWNLOAD
  ========================================= */

  const handleDownloadSelected =
    async () => {

      if (
        selectedIds.length === 0
      ) {

        alert(
          "Please select candidates"
        );

        return;
      }

      const selected =
        candidates.filter((c) =>
          selectedIds.includes(
            c.id
          )
        );

      const doc =
        new Document({

          sections:
            selected.map((c) => ({

              children: [

                new Paragraph({

                  children: [

                    new TextRun({

                      text:
                        "Candidate Details",

                      bold: true,

                      size: 28,
                    }),
                  ],
                }),

                new Paragraph(
                  `Name : ${c.firstName} ${c.lastName}`
                ),

                new Paragraph(
                  `Email : ${c.email}`
                ),

                new Paragraph(
                  `Phone : ${c.phone}`
                ),

                new Paragraph(
                  `Experience : ${c.experience}`
                ),

                new Paragraph(
                  `Skills : ${c.keySkills}`
                ),

                new Paragraph(
                  `Qualification : ${c.qualification}`
                ),

                new Paragraph(
                  `Location : ${c.location}`
                ),

                new Paragraph(
                  `Status : ${c.status}`
                ),
              ],
            })),
        });

      const blob =
        await Packer.toBlob(
          doc
        );

      saveAs(
        blob,
        "employee_candidates.docx"
      );
    };

  /* =========================================
      VIEW CANDIDATE
  ========================================= */

  const handleViewCandidate = (
    candidate
  ) => {

    navigate(
      `/dashboard/Employeejobproview/${candidate.id}`,
      {
        state: {
          candidate,
        },
      }
    );
  };

  /* =========================================
      UI
  ========================================= */

  return (

    <div className="container-fluid py-3 mt-5">

      <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap gap-3">

        <div>

          <button
            className="btn btn-outline-secondary btn-sm mb-2"
            onClick={() =>
              navigate(-1)
            }
          >

            <FaArrowLeft />
            {" "}
            Back

          </button>

          <h5>
            Candidates Responses
          </h5>

          <small className="text-muted">

            Position :
            {" "}

            <span className="fw-bold">

              {jobTitle}

            </span>

          </small>

        </div>

        <div className="d-flex flex-wrap gap-2">

          <Button
            variant="success"
            size="sm"
            onClick={() =>
              bulkUpdateStatus(
                "Shortlisted"
              )
            }
          >

            <SiTicktick />
            {" "}
            Shortlist

          </Button>

          <Button
            variant="warning"
            size="sm"
          >

            <ImConfused />
            {" "}
            Maybe

          </Button>

          <Button
            variant="danger"
            size="sm"
            onClick={() =>
              bulkUpdateStatus(
                "Rejected"
              )
            }
          >

            <MdOutlineBlock />
            {" "}
            Reject

          </Button>

          <Button
            variant="primary"
            size="sm"
          >

            <HiOutlineMail />
            {" "}
            Email

          </Button>

          <Button
            variant="secondary"
            size="sm"
          >

            <RiShareForwardLine />
            {" "}
            Forward

          </Button>

          <Button
            variant="outline-secondary"
            size="sm"
            onClick={
              handleDownloadSelected
            }
          >

            <RiDownloadFill />
            {" "}
            Download

          </Button>

          <Button
            variant="outline-danger"
            size="sm"
            onClick={handleDelete}
          >

            <MdOutlineDeleteOutline />
            {" "}
            Delete

          </Button>

        </div>

      </div>

      {/* COUNTS */}

      <div className="d-flex flex-wrap gap-3 mb-4">

        <button className="btn btn-outline-primary">

          Total Responses :
          {" "}
          {totalResponses}

        </button>

        <button className="btn btn-outline-success">

          Shortlisted :
          {" "}
          {shortlistedCount}

        </button>

        <button className="btn btn-outline-warning">

          Maybe :
          {" "}
          {maybeCount}

        </button>

        <button className="btn btn-outline-danger">

          Rejected :
          {" "}
          {rejectedCount}

        </button>

      </div>

      {/* FILTERS */}

      <div className="card p-3 mb-4">

        <div className="row g-3">

          <div className="col-md-3">

            <label className="form-label">
              Status
            </label>

            <select
              className="form-select"
              value={statusFilter}
              onChange={(e) => {

                setStatusFilter(
                  e.target.value
                );

                setPage(1);

              }}
            >

              <option value="all">
                All
              </option>

              <option value="shortlisted">
                Shortlisted
              </option>

              <option value="rejected">
                Rejected
              </option>

              <option value="maybe">
                Maybe
              </option>

              <option value="applied">
                Applied
              </option>

            </select>

          </div>

          <div className="col-md-3">

            <label className="form-label">
              Name
            </label>

            <input
              type="text"
              className="form-control"
              placeholder="Search name"
              value={nameFilter}
              onChange={(e) => {

                setNameFilter(
                  e.target.value
                );

                setPage(1);

              }}
            />

          </div>

          <div className="col-md-3">

            <label className="form-label">
              Email
            </label>

            <input
              type="text"
              className="form-control"
              placeholder="Search email"
              value={emailFilter}
              onChange={(e) => {

                setEmailFilter(
                  e.target.value
                );

                setPage(1);

              }}
            />

          </div>

          <div className="col-md-3">

            <label className="form-label">
              Experience
            </label>

            <input
              type="text"
              className="form-control"
              placeholder="Search experience"
              value={experienceFilter}
              onChange={(e) => {

                setExperienceFilter(
                  e.target.value
                );

                setPage(1);

              }}
            />

          </div>

        </div>

      </div>

      {/* TABLE */}

      <div className="table-responsive">

        <table className="table table-bordered table-hover align-middle">

          <thead className="table-light">

            <tr>

              <th>

                <input
                  type="checkbox"
                  checked={allSelected}
                  onChange={toggleSelectAll}
                />

              </th>

              <th>Name</th>

              <th>Email</th>

              <th>Phone</th>

              <th>Experience</th>

              <th>Skills</th>

              <th>Status</th>

              <th>Action</th>

            </tr>

          </thead>

          <tbody>

            {loading ? (

              <tr>

                <td
                  colSpan="8"
                  className="text-center py-5"
                >

                  <div className="spinner-border text-primary" />

                </td>

              </tr>

            ) : paged.length > 0 ? (

              paged.map((c) => (

                <tr key={c.id}>

                  <td>

                    <input
                      type="checkbox"
                      checked={selectedIds.includes(
                        c.id
                      )}
                      onChange={() =>
                        toggleSelect(c.id)
                      }
                    />

                  </td>

                  <td>

                    {c.firstName}
                    {" "}
                    {c.lastName}

                  </td>

                  <td
                    style={{
                      wordBreak:
                        "break-word",
                    }}
                  >

                    {c.email}

                  </td>

                  <td>
                    {c.phone}
                  </td>

                  <td>
                    {c.experience}
                  </td>

                  <td
                    style={{
                      minWidth: "180px",
                    }}
                  >

                    {c.keySkills}

                  </td>

                  <td>

                    <span
                      className={`badge ${getStatusBadgeClass(
                        c.status
                      )}`}
                    >

                      {c.status}

                    </span>

                  </td>

                  <td>

                    <button
                      className="btn btn-sm btn-outline-primary"
                      onClick={() =>
                        handleViewCandidate(
                          c
                        )
                      }
                    >

                      <Eye size={14} />
                      {" "}
                      View

                    </button>

                  </td>

                </tr>
              ))

            ) : (

              <tr>

                <td
                  colSpan="8"
                  className="text-center py-5"
                >

                  No Candidates Found

                </td>

              </tr>
            )}

          </tbody>

        </table>

      </div>

      {/* PAGINATION */}

      <div className="d-flex justify-content-between align-items-center mt-3 flex-wrap gap-3">

        <small className="text-muted">

          Showing
          {" "}

          {filteredAll.length === 0
            ? 0
            : (page - 1) * pageSize + 1}

          -

          {Math.min(
            page * pageSize,
            filteredAll.length
          )}

          {" "}of{" "}

          {filteredAll.length}

        </small>

        <div>

          <button
            className="btn btn-primary btn-sm me-2"
            disabled={page === 1}
            onClick={() =>
              setPage(page - 1)
            }
          >

            Previous

          </button>

          <button
            className="btn btn-primary btn-sm"
            disabled={
              page === totalPages
            }
            onClick={() =>
              setPage(page + 1)
            }
          >

            Next

          </button>

        </div>

      </div>

    </div>
  );
}

export default Empresponse;